// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sidebar */
.aims-sidebar {
    background: #fff;
    display: flex;
    flex-shrink: 1;
    border-right: 1px solid #e2e2e2;
    height: calc(100vh - 48px);
}

.aims-close-sidebar {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
}

.aims-close-sidebar button {
    color: #333;
    font-size: 18px;
}

.aims-sidebar-btn-wrap {
    display: flex;
    flex-direction: column;
    width: 77px;
    flex-shrink: 0;
}

.aims-sidebar-outer {
    background-color: #fff;
}

.aims-btn-reset.aims-sidebar-btn {
    height: 90px;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    position: relative;
}

.aims-sidebar-btn:not(.aims-sidebar-btn--selected):hover {
    color: var(--color-interactive-primary-hover);
}

.aims-sidebar-btn:not(.aims-sidebar-btn--selected):hover:after {
    content: '';
    width: 5px;
    height: 60px;
    position: absolute;
    background: #e2e2e2;
    left: 0;
}

.aims-sidebar-btn--selected:after {
    content: '';
    width: 5px;
    height: 60px;
    position: absolute;
    background: var(--color-interactive-primary-hover);
    left: 0;
}

.aims-sidebar-btn--bottom-border {
    border-bottom: 1px solid var(--color-border-container) !important;
}

.aims-sidebar-expanded {
    width: 280px;
    flex-shrink: 1;
    border-left: 1px solid #B7B7B7;
    padding: 8px 16px;
    /* border: 4px solid red; */
    overflow-y: auto;
    overflow-x: visible;
    height: 100%;
    box-sizing: border-box;
}

.aims-sidebar-icon {
    font-size: 17px;
}

.aims-sidebar-mobile {
    display: none;
    padding: 0 8px;
    box-sizing: border-box;
}

.aims-sidebar-mobile-btn.aims-btn-reset {
    padding: 16px 0;
    display: flex;
    border-bottom: 1px solid #E2E2E2;
    width: 100%;
    gap: 8px;
    padding-left: 8px;
    justify-content: flex-start;
    align-items: center;
}

.aims-sidebar-mobile-btn .aims-sidebar-icon {
    position: relative;
    top: 1px;
}

@media only screen and (max-width: 800px) {
    .aims-wrap--drawer-open .aims-sidebar {
        /* border: 5px solid red; */
        flex-shrink: 0;
        width: 100vw;
        box-sizing: border-box;
    }

    .aims-sidebar-expanded {
        width: calc(100vw - 77px);
        flex-shrink: 1;
    }

    .aims-wrap--drawer-open .aims-main-wrap {
        display: none;
    }
}

@media only screen and (max-width: 500px) {
    .aims-sidebar {
        display: none;
    }

    .aims-wrap--mobile-drawer-open .aims-sidebar-mobile {
        display: block;
        width: 100vw;
        flex-shrink: 0;
    }

    .aims-wrap--mobile-drawer-open .aims-main-wrap {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/style/sidebar.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;IACI,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,+BAA+B;IAC/B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,kDAAkD;IAClD,OAAO;AACX;;AAEA;IACI,iEAAiE;AACrE;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,8BAA8B;IAC9B,iBAAiB;IACjB,2BAA2B;IAC3B,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,aAAa;IACb,gCAAgC;IAChC,WAAW;IACX,QAAQ;IACR,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI;QACI,2BAA2B;QAC3B,cAAc;QACd,YAAY;QACZ,sBAAsB;IAC1B;;IAEA;QACI,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;QACd,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* sidebar */\n.aims-sidebar {\n    background: #fff;\n    display: flex;\n    flex-shrink: 1;\n    border-right: 1px solid #e2e2e2;\n    height: calc(100vh - 48px);\n}\n\n.aims-close-sidebar {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 8px;\n}\n\n.aims-close-sidebar button {\n    color: #333;\n    font-size: 18px;\n}\n\n.aims-sidebar-btn-wrap {\n    display: flex;\n    flex-direction: column;\n    width: 77px;\n    flex-shrink: 0;\n}\n\n.aims-sidebar-outer {\n    background-color: #fff;\n}\n\n.aims-btn-reset.aims-sidebar-btn {\n    height: 90px;\n    font-size: 14px;\n    font-weight: 500;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    position: relative;\n}\n\n.aims-sidebar-btn:not(.aims-sidebar-btn--selected):hover {\n    color: var(--color-interactive-primary-hover);\n}\n\n.aims-sidebar-btn:not(.aims-sidebar-btn--selected):hover:after {\n    content: '';\n    width: 5px;\n    height: 60px;\n    position: absolute;\n    background: #e2e2e2;\n    left: 0;\n}\n\n.aims-sidebar-btn--selected:after {\n    content: '';\n    width: 5px;\n    height: 60px;\n    position: absolute;\n    background: var(--color-interactive-primary-hover);\n    left: 0;\n}\n\n.aims-sidebar-btn--bottom-border {\n    border-bottom: 1px solid var(--color-border-container) !important;\n}\n\n.aims-sidebar-expanded {\n    width: 280px;\n    flex-shrink: 1;\n    border-left: 1px solid #B7B7B7;\n    padding: 8px 16px;\n    /* border: 4px solid red; */\n    overflow-y: auto;\n    overflow-x: visible;\n    height: 100%;\n    box-sizing: border-box;\n}\n\n.aims-sidebar-icon {\n    font-size: 17px;\n}\n\n.aims-sidebar-mobile {\n    display: none;\n    padding: 0 8px;\n    box-sizing: border-box;\n}\n\n.aims-sidebar-mobile-btn.aims-btn-reset {\n    padding: 16px 0;\n    display: flex;\n    border-bottom: 1px solid #E2E2E2;\n    width: 100%;\n    gap: 8px;\n    padding-left: 8px;\n    justify-content: flex-start;\n    align-items: center;\n}\n\n.aims-sidebar-mobile-btn .aims-sidebar-icon {\n    position: relative;\n    top: 1px;\n}\n\n@media only screen and (max-width: 800px) {\n    .aims-wrap--drawer-open .aims-sidebar {\n        /* border: 5px solid red; */\n        flex-shrink: 0;\n        width: 100vw;\n        box-sizing: border-box;\n    }\n\n    .aims-sidebar-expanded {\n        width: calc(100vw - 77px);\n        flex-shrink: 1;\n    }\n\n    .aims-wrap--drawer-open .aims-main-wrap {\n        display: none;\n    }\n}\n\n@media only screen and (max-width: 500px) {\n    .aims-sidebar {\n        display: none;\n    }\n\n    .aims-wrap--mobile-drawer-open .aims-sidebar-mobile {\n        display: block;\n        width: 100vw;\n        flex-shrink: 0;\n    }\n\n    .aims-wrap--mobile-drawer-open .aims-main-wrap {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
